import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3efbdbb5&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3efbdbb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efbdbb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3efbdbb5')) {
      api.createRecord('3efbdbb5', component.options)
    } else {
      api.reload('3efbdbb5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3efbdbb5&scoped=true&", function () {
      api.rerender('3efbdbb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/index.vue"
export default component.exports